import React from "react";
import { ExternalLink } from "lucide-react";
import { useLang } from "../LanguageContext";
import { HELLOASSO_URL, HELLOASSO_WIDGET_URL } from "../config";

const FEATURE_IMG = "https://customer-assets-4nw71qhi.emergentagent.net/job_ecole-pleine-nature/artifacts/zk21332w_atelier.webp";

export default function Don() {
  const { t } = useLang();

  return (
    <div data-testid="page-don">
      <section className="container-page pt-16 sm:pt-24 pb-8">
        <div className="grid md:grid-cols-[minmax(0,1fr)_13rem] gap-8 md:gap-10 items-start">
          <div>
            <p className="eyebrow mb-4">{t("don.eyebrow")}</p>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-medium text-ink max-w-3xl leading-tight">
              {t("don.title")}
            </h1>
            <p className="mt-6 text-lg text-ink-muted leading-relaxed max-w-2xl">{t("don.intro")}</p>
            <p className="mt-4 text-sm text-ink-muted/90 leading-relaxed max-w-2xl border-l-2 border-forest-light pl-4">
              {t("don.tax")}
            </p>
          </div>
          <div className="rounded-[1.75rem] overflow-hidden shadow-soft bg-cream-100 shrink-0">
            <img
              src={FEATURE_IMG}
              alt="École Pleine Nature — travail collaboratif"
              className="w-full h-auto block"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="container-page pb-24">
        <div className="card-soft overflow-hidden p-2 sm:p-4">
          <iframe
            id="haWidget"
            title="Faire un don — HelloAsso"
            src={HELLOASSO_WIDGET_URL}
            className="w-full border-0 rounded-[1.25rem] bg-cream-50 block"
            style={{ minHeight: "860px" }}
            allow="payment"
            data-testid="hello-asso-iframe"
          />
        </div>
        <p className="mt-5 text-sm text-ink-muted text-center">
          <a
            href={HELLOASSO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-forest hover:text-forest-dark underline underline-offset-4"
            data-testid="don-fallback-link"
          >
            {t("don.fallback")} <ExternalLink size={15} />
          </a>
        </p>
      </section>
    </div>
  );
}
